import { render, staticRenderFns } from "./ServiceDescriptionSetupForm.vue?vue&type=template&id=0fdebc5e&scoped=true&"
import script from "./ServiceDescriptionSetupForm.vue?vue&type=script&lang=js&"
export * from "./ServiceDescriptionSetupForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescriptionSetupForm.vue?vue&type=style&index=0&id=0fdebc5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdebc5e",
  null
  
)

export default component.exports